import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import CardDropdown from "components/common/CardDropdown";
import IconButton from "components/common/IconButton";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
import { settings } from "config";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Card, Dropdown, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import {
  resetColumnState,
  restoreColumnState,
  saveColumnState,
} from "utils/tablesUtils";
import "./styles.css";
import { VouchersAPI } from "api";
import { useSettingContext } from "context/SettingContext";
import { formatDate } from "date-fns";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

export default function VouchersTable() {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";
  const navigate = useNavigate();
  const columnApiRef = useRef();
  const gridRef = useRef();

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState([
    {
      field: "number",
      headerName: "Number",
      hide: false,
      flex: 2,
    },
    {
      field: "type",
      headerName: "Type",
      hide: false,
      flex: 2.5,
    },
    {
      field: "date",
      headerName: "Date",
      hide: false,
      flex: 1.5,
      cellRenderer: (p) => {
        const date = p?.data?.date
          ? new Date(p.data?.date).toLocaleDateString()
          : "";
        return <div>{date}</div>;
      },
    },
    {
      field: "postingDate",
      headerName: "Posting Date",
      hide: false,
      flex: 1.5,
      cellRenderer: (p) => {
        const date = p?.data?.postingDate
          ? new Date(p.data.postingDate).toLocaleDateString()
          : "";
        return <div>{date}</div>;
      },
    },
    {
      field: "postingStatus",
      headerName: "Posting Status",
      hide: false,
      flex: 1.5,
    },
    {
      field: "financeBooksArray",
      headerName: "Finance Books",
      hide: false,
      flex: 1.5,
      cellRenderer: (p) => {
        // const fBooks = p?.data?.financeBooksArray || [];
        // return (
        //   <div style={{ display: "flex", flexWrap: "wrap", gap: "2px" }}>
        //     {fBooks?.map((book, index) => (
        //       <SubtleBadge key={index} pill bg="primary" className="me-2">
        //         {book}
        //       </SubtleBadge>
        //     ))}
        //   </div>
        // );

        const fBook = p?.data?.financeBooksArray
          ? p?.data?.financeBooksArray.map((d) => d).join(", ")
          : "";
        return <div>{fBook}</div>;
      },
    },
    // {
    //   field: "status",
    //   headerName: "Active",
    //   flex: 1.5,
    //   hide: false,
    //   filter: false,
    //   cellStyle: {
    //     display: "flex",
    //     // paddingRight: "30px",
    //     justifyContent: "center",
    //   },
    //   headerClass: "center-header",
    //   cellRenderer: (p) => (
    //     <Form.Check
    //       type="checkbox"
    //       id="statusSwitch"
    //       style={{ padding: "10px 0px" }}
    //       checked={p?.data.status}
    //     />
    //   ),
    // },
    {
      headerName: "Action",
      field: "action",
      flex: 1.5,
      filter: false,
      headerClass: "center-header",
      cellStyle: {
        display: "flex",
        justifyContent: "center",
      },
      cellRenderer: (p) => (
        <CardDropdown>
          <div className="py-2">
            <Dropdown.Item
              // as={Link}
              onClick={() =>
                // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
                // () =>
                handleRowClick(p.data)
              }
              // href="/products/add-product"
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdOutlineModeEdit />
              Edit
            </Dropdown.Item>
            {/* <Dropdown.Item
              // onClick={() => handleDelete()}
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdDeleteOutline />
              Delete
            </Dropdown.Item> */}
          </div>
        </CardDropdown>
      ),
    },
  ]);

  const settingsData = useSettingContext();

  const costCenter = useMemo(
    () => settingsData?.find((d) => d.name === "DEFAULT_COST_CENTER"),
    [settingsData]
  );

  const costCenterId = Number(costCenter?.value); // Ensure it's a number

  const handleRowClick = (data) => {
    if (data) {
      navigate(`${CONSTANT_ROUTES.VOUCHER_ADD}`, { state: data });
    }
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    // floatingFilter: true,
    // flex: 1,
    // rowDrag: true,
  };

  //   ===============Custom Api Call start================

  let gridApi;
  let columnApi;

  // const onGridReady = useCallback(
  //   (e) => {
  //     gridApi = e.api;
  //     columnApi = e.columnApi;
  //     restoreState();
  //     // CostCenterAPI.get().then((res) => {
  //     //   e.api.applyTransaction({ add: res?.data?.data });
  //     // });
  //   },
  //   [window]
  // );

  const gridApiRef = useRef(null);

  const onGridReady = useCallback((e) => {
    gridApiRef.current = e.api; // Store API in ref
    restoreState();
    fetchData();
  }, []);

  const fetchData = useCallback(() => {
    if (!gridApiRef.current) return; // Ensure API is set

    // gridApiRef.current.showLoadingOverlay();

    if (!costCenterId) {
      // gridApiRef.current.setRowData([]); // Clear table
      // gridApiRef.current.showNoRowsOverlay(); // Show "No records found"
      return;
    }

    VouchersAPI.get({ params: { costCenterId } })
      .then((res) => {
        gridApiRef.current.setRowData(res?.data?.data || []); // Set data properly
      })
      .catch(() => {
        gridApiRef.current.setRowData([]); // Clear on failure
      })
      .finally(() => {
        gridApiRef.current.hideOverlay();
      });
  }, [costCenterId]);

  useEffect(() => {
    fetchData();
  }, [costCenterId, fetchData]);

  const saveState = useCallback(() => {
    saveColumnState("vouchers-table", columnApiRef);
  }, []);

  const restoreState = useCallback(() => {
    restoreColumnState("vouchers-table", columnApiRef);
  }, []);

  const resetState = useCallback(() => {
    resetColumnState("vouchers-table", columnApiRef);
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    columnApiRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);

  return (
    <div>
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <PageTitle name="Accounts | Vouchers | Entries" />

      <div
        className={`${
          isDarkBool || isDarkTheme || auto
            ? "ag-theme-quartz-dark"
            : "ag-theme-quartz"
        } rounded-0`} // applying the grid theme
        // style={{ height: "100vh" }} // the grid will fill the size of the parent container
      >
        <Card style={{ height: `calc(100vh - 4rem)`, overflow: "auto" }}>
          <Card.Header className="d-flex justify-content-between align-items-center">
            {/* <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
              {" "}
              Accounts | Vouchers | Entries
            </h5> */}
            <BreadCrumbTable
              title="Accounts"
              subTitle="Vouchers"
              subTitle2="Entries"
            />
            <div className="d-flex align-items-center gap-2">
              <Form className="position-relative">
                <FontAwesomeIcon
                  icon="search"
                  className="position-absolute text-400 search-box-icon"
                  style={{
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
                <Form.Control
                  type="search"
                  placeholder="Search..."
                  style={{
                    paddingLeft: "30px",
                  }}
                  aria-label="Search"
                  id="filter-text-box"
                  className="rounded-pill search-input"
                  onInput={onFilterTextBoxChanged}
                />
              </Form>
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    New
                  </Tooltip>
                }
              >
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  onClick={() => navigate(CONSTANT_ROUTES.VOUCHER_ADD)}
                >
                  <span className="d-none d-sm-inline-block ms-1">New</span>
                </IconButton>
              </OverlayTrigger>
              <TableHeaderDropdown>
                <div className="py-2">
                  <Dropdown.Item
                    onClick={saveState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Save State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={restoreState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Restore State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={resetState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Reset State
                  </Dropdown.Item>
                </div>
              </TableHeaderDropdown>
            </div>
          </Card.Header>

          <Card.Body className="p-0">
            <AgGridReact
              // rowData={rowData}
              ref={columnApiRef}
              pagination
              paginationPageSize={settings.paginationSize}
              onGridReady={onGridReady}
              columnDefs={colDefs}
              headerHeight={35}
              rowHeight={35}
              defaultColDef={defaultColDef}
              onRowDoubleClicked={(params) => handleRowClick(params.data)}
              overlayNoRowsTemplate="Nothing found - Looks empty over here"
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
